import styled from 'styled-components';

export const UserControlsList = styled.ul`
  padding-bottom: 0;
`;
